<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.666 3.3335H3.33268C2.40768 3.3335 1.67435 4.07516 1.67435 5.00016L1.66602 15.0002C1.66602 15.9252 2.40768 16.6668 3.33268 16.6668H16.666C17.591 16.6668 18.3327 15.9252 18.3327 15.0002V5.00016C18.3327 4.07516 17.591 3.3335 16.666 3.3335ZM16.666 15.0002H3.33268V10.0002H16.666V15.0002ZM3.33268 6.66683H16.666V5.00016H3.33268V6.66683Z" fill="#151515" />
  </svg>
</template>
